import { openDB } from "idb";

const DB = "sfap-amis-offline";
let dbp;
const getDb = () => {
  if (!dbp) dbp = openDB(DB, 1, { upgrade(db) { db.createObjectStore("keys"); db.createObjectStore("vault"); } });
  return dbp;
};

async function key() {
  const db = await getDb();
  let k = await db.get("keys", "aes");
  if (!k) {
    k = await crypto.subtle.generateKey({ name: "AES-GCM", length: 256 }, false, ["encrypt", "decrypt"]);
    await db.put("keys", k, "aes");
  }
  return k;
}

export async function vaultSet(name, value) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const data = new TextEncoder().encode(JSON.stringify(value));
  const ct = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, await key(), data);
  const db = await getDb();
  await db.put("vault", { iv, ct }, name);
}

export async function vaultGet(name, fallback = null) {
  const db = await getDb();
  const row = await db.get("vault", name);
  if (!row) return fallback;
  const pt = await crypto.subtle.decrypt({ name: "AES-GCM", iv: row.iv }, await key(), row.ct);
  return JSON.parse(new TextDecoder().decode(pt));
}

export async function vaultDel(name) {
  const db = await getDb();
  await db.delete("vault", name);
}

export async function requestPersist() {
  try {
    if (navigator.storage?.persist) return await navigator.storage.persist();
  } catch (e) {
    return false;
  }
  return false;
}

export const newId = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
